import {
  PREGUNTASFRECUENTES_LOADING,
  PREGUNTASFRECUENTES_SUCCESS,
  PREGUNTASFRECUENTES_ERROR,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const wsGetFAQ = (nextStep) => (dispatch) => {
  dispatch({ type: PREGUNTASFRECUENTES_LOADING });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/shared/textos/GetPreguntasFrecuentes/AtencionSinTurno`)
      .then((resp) => {
        dispatch({
          type: PREGUNTASFRECUENTES_SUCCESS,
          payload: resp.data,
        });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: PREGUNTASFRECUENTES_ERROR, payload: err.data });
        if (nextStep) nextStep(false, err.response.data);
      });
  });
};
// export const wsGetFAQ = (nextStep) => (dispatch) => {
//   dispatch({ type: PREGUNTASFRECUENTES_LOADING });
//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get(`/texto/GetPreguntasFrecuentes/AtencionSinTurno`)
//       .then((resp) => {
//         dispatch({
//           type: PREGUNTASFRECUENTES_SUCCESS,
//           payload: resp.data,
//         });
//         if (nextStep) nextStep(true, resp.data);
//       })
//       .catch((err) => {
//         dispatch({ type: PREGUNTASFRECUENTES_ERROR, payload: err.data });
//         if (nextStep) nextStep(false, err.response.data);
//       });
//   });
// };
